<template>
  <div>
    <p>Your ear tags must ship to the following address:</p>

    <address class="address text-normal text-uppercase">
      {{ flock.address.first_name }} {{ flock.address.last_name }}<br>
      {{ flock.address.street }}<br>
      {{ flock.address.city }}, {{ flock.address.state }} {{ flock.address.zip }}
    </address>

    <div style="margin-top: 1em;">
      <label
        class="wrapping-label"
        :class="{'parsley-error': 'confirm' in errors}">
        <input
          type="checkbox"
          v-model="flock.confirm"
          @input="$emit('update', flock)"
        >
        <span class="label-contents" style="padding-left: 2em;">
          I confirm this is the correct address associated with my flock, and the location my tags should be&nbsp;shipped.
        </span>
      </label>
      <div
        class="error-text"
        v-if="'confirm' in errors" v-html="errors.confirm"
      ></div>
    </div>

    <p class="text-smaller">If you need to ship to a different address, please call <a class="text-bold" style="color:inherit;white-space:nowrap;" href="tel:8668732824">(866) 873-2824</a> to update your address on&nbsp;file.</p>

  </div>
</template>

<script>
export default {
  props: {
    flock: {
      type: Object,
      default: () => {
        return {
          address: {
            street: '',
            city: '',
            state: '',
            zip: '',
          },
          confirm: false,
        };
      },
    },
  },

  data() {
    return {
      errors: {},
    };
  },

  methods: {
    validate() {
      this.errors = {};

      if(this.flock.confirm !== true) {
        this.errors['confirm'] = 'You must confirm your address.';
      }

      return !(Object.keys(this.errors).length > 0);
    },
  },
}
</script>

<style scoped>
.address {
  border: 1px dashed #CCC;
  line-height: 1.25em;
  padding: .5em;
}
</style>
